export default {
  namespaced: true,
  share_video_link: {
    title: "share video link",
    modal_title: "password is required to view the video",
    password: "password",
    password_error: "incorrect password",
    expired_link: "expired video link",
  },
}
